import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

export function useQueryApi({
  endpoint,
  enable = true,
  callbackFn,
  dependency
}) {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { getAccessTokenSilently } = useAuth0()

  useEffect(
    function callApi() {
      // Función para realizar la solicitud
      const fetchData = async () => {
        const accessToken = await getAccessTokenSilently()
        setIsLoading(true)
        fetch(endpoint, { headers: { Authorization: `Bearer ${accessToken}` } })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok')
            }
            return response.json()
          })
          .then((data) => {
            if (callbackFn) {
              callbackFn(data)
            }
            setData(data)
          })
          .catch((error) => {
            console.error('Data fetching error:', error)
            setData(null)
          })
          .finally(() => {
            setIsLoading(false)
          })
      }

      if (enable) {
        fetchData()
      }
    },
    [enable, endpoint, callbackFn, dependency, getAccessTokenSilently]
  )

  return { data, isLoading }
}
